module.exports = __webpack_public_path__ + "static/media/dianshang11.e6d5539e.png";